module.exports = __webpack_public_path__ + "img/Newbie_Dagger_02_Warrior.fed0dee6.png";